import { useTranslation } from "react-i18next";
import { useAuth } from "@/shared/auth/useAuth";
import { Button } from "@/shared/components/ui/button";

export function ForbiddenPage() {
  const { t } = useTranslation();
  const { signOut } = useAuth();

  return (
    <div
      data-testid="forbidden-screen"
      className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center"
    >
      <h1 className="text-3xl font-semibold">{t("errors.forbiddenTitle")}</h1>
      <p className="max-w-md text-muted-foreground">{t("errors.forbiddenBody")}</p>
      <Button
        data-testid="forbidden-sign-out-button"
        variant="outline"
        onClick={() => void signOut()}
      >
        {t("nav.signOut")}
      </Button>
    </div>
  );
}
